import { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Table, Card, Modal } from "antd";
import { req_list_rts_student } from "../../api";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import RemoteLearningSelfWeekLogModal from "./remote-learning-self-week-log-modal";
class RemoteLearningStudentModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    data: [],
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    academicYear: getNowAcademicYear(new Date()),
    academicSemester: getNowAcademicSemester(new Date()),
    domnloadFile: "",
    isShowModal: false,
    academicCredit: 0,
    threshold: 0,
  };

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_list_items();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  api_list_items = async () => {
    const { OpenCourseKeyId } = this.props.data;
    const { token, role, userCode } = this.props.user;
    console.log(this.props.data);

    var userLevel = usrRole(role);
    this.setState({
      loading: true,
    });
    const result = await req_list_rts_student(
      userLevel,
      userCode,
      OpenCourseKeyId,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      console.log(items);
      this.setState({
        data: items,
        loading: false,
      });
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  handle_btn_event = (modal, item) => {
    switch (modal) {
      case "list_timelog":
        this.setState({ item, isShowModal: true });
        break;
      case "download":
        break;
      default:
    }
  };

  render() {
    const {
      AcademicYear,
      AcademicSemeter,
      ClassroomName,
      CourseName,
      TeacherName,
    } = this.props.data;
    const { data, loading, isShowModal, item} = this.state;
    const columns = [
      {
        title: "學號",
        dataIndex: "StudentId",
        key: "StudentId",
        responsive: ["md"],
        render: (text) => <>{text}</>,
      },
      {
        title: "姓名",
        dataIndex: "StudentName",
        key: "StudentName",
        render: (text) => <>{text}</>,
      },
       {
        title: "學習記錄",
        width: 120,
        render: (item) => (
          <div style={{ textAlign: "center" }}>
            <button
              className={
                item.StudentInfoStatus === "PASS"
                  ? "btn btn-success btn-sm"
                  : "btn btn-danger btn-sm"
              }
              style={{ width: "110px" }}
              onClick={() => this.handle_btn_event("list_timelog", item)}
            >
              {item.StudentInfoStatus === "PASS" ? "已達標" : "未達標"}{" "}
              <hr />
              平均 {item.StudentAverage} 分鐘
            </button>
          </div>
        ),
      },
    ];
    return (
      <Card>
        <h3>
          {" "}
          {AcademicYear}-{AcademicSemeter} {ClassroomName}/{CourseName}/
          {TeacherName} 老師
        </h3>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
          scroll={{
            y: 55 * 5,
          }}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowModal}
          width={600}
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <RemoteLearningSelfWeekLogModal data={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(RemoteLearningStudentModal);
